import { css } from '@linaria/core';
import { baseTheme } from 'styles/utils';
export const dialogWrapper = "odules__Apps__components__apiKeyTable__styles_ts-dialogWrapper-drm2h9i";
export const dialog = "odules__Apps__components__apiKeyTable__styles_ts-dialog-d51ltiy";
export const dialogOuterContentWrapper = "odules__Apps__components__apiKeyTable__styles_ts-dialogOuterContentWrapper-d15c7f6u";
export const dialogContentWrapper = "odules__Apps__components__apiKeyTable__styles_ts-dialogContentWrapper-dhue0p4";
export const formContainer = "odules__Apps__components__apiKeyTable__styles_ts-formContainer-f1xo3a8y";

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");